import {Dish} from './Dish';
import {SignIn} from './SignIn';
import {Search} from './Search';
import {SignUp} from './SignUp';
import {Filter} from './Filter';
import {Reviews} from './Reviews';
import {MenuList} from './MenuList';
import {Checkout} from './Checkout';
import {Onboarding} from './Onboarding';
import {Promocodes} from './Promocodes';
import {EditProfile} from './EditProfile';
import {NewPassword} from './NewPassword';
import {OrderFailed} from './OrderFailed';
import {LeaveAReview} from './LeaveAReview';
import {OrderHistory} from './OrderHistory';
import {TrackYourOrder} from './TrackYourOrder';
import {ForgotPassword} from './ForgotPassword';
import {OrderSuccessful} from './OrderSuccessful';
import {PromocodesEmpty} from './PromocodesEmpty';
import {ConfirmationCode} from './ConfirmationCode';
import {OrderHistoryEmpty} from './OrderHistoryEmpty';
import {SignUpAccountCreated} from './SignUpAccountCreated';
import {VerifyYourPhoneNumber} from './VerifyYourPhoneNumber';
import {ForgotPasswordSentEmail} from './ForgotPasswordSentEmail';
import { MyAddress } from './MyAddress';
import { AddressAdd } from './AddressAdd';
import {ClientNotification} from '../screens/ClientNotification';
import {ClientNotificationDetails} from './ClientNotificationDetails'
import { CustomerCare } from './CustomerCare';
import {SubscriptionOrder} from './tabs/SubscriptionOrder'
import {WalletHistory} from '../screens/WalletHistory'
import {SubscriptionModify} from '../screens/SubscriptionModify'
import {CouponList} from './CouponList'
import { CouponSummary } from './CouponSummary';
import {SubscriptionOrderCheck} from '../screens/tabs/SubscriptionOrderCheck'
import { OrderItemCoupon} from '../items/OrderItemCoupon';
import {SelectMyAddress} from './SelectMyAddress';
import ThankYouPage from './ThankYouPage';
import { NewUsereAddAddress } from './NewUsereAddAddress';
import {SelectAddressFromHome} from './SelectAddressFromHome';

export const screens = {
  OrderItemCoupon,
  Dish,
  SignIn,
  Search,
  SignUp,
  Filter,
  Reviews,
  MenuList,
  Checkout,
  Onboarding,
  Promocodes,
  EditProfile,
  OrderFailed,
  NewPassword,
  LeaveAReview,
  OrderHistory,
  ForgotPassword,
  TrackYourOrder,
  OrderSuccessful,
  PromocodesEmpty,
  ConfirmationCode,
  OrderHistoryEmpty,
  SignUpAccountCreated,
  VerifyYourPhoneNumber,
  ForgotPasswordSentEmail,
  MyAddress,
  AddressAdd,
  ClientNotification,
  ClientNotificationDetails,
  CustomerCare,
  SubscriptionOrder,
  WalletHistory,
  SubscriptionModify,
  CouponList,
  CouponSummary,
  SubscriptionOrderCheck,
  SelectMyAddress,
  ThankYouPage,
  NewUsereAddAddress,
  SelectAddressFromHome
};
